'use client'

import { ClientHelpModule } from 'help/components/HelpModule/client/ClientHelpModule'
import { type GetQuestionResponse } from 'help/types/types'
import { useUserDetails } from 'user-data/hooks/useUserDetails'

import { useMyAccount } from '../../contexts/MyAccountProvider'
import { useQuestionsIds } from '../../hooks/useQuestionsIds'
import { getFilteredQuestions } from '../../utils/getFilteredQuestions/getFilteredQuestions'
import { ModalHelp } from '../ModalHelp/ModalHelp'

type UserHelpType = (GetQuestionResponse | null)[]

export const UserHelp = ({
	allQuestions,
}: {
	readonly allQuestions: UserHelpType
}) => {
	const {
		userInfo: { activePurchases },
	} = useMyAccount()
	const questionsIds = useQuestionsIds()
	const userDetails = useUserDetails()

	if (activePurchases.length) {
		return null
	}
	if (!userDetails || !userDetails.loyalty) {
		return null
	}

	if (!questionsIds || !allQuestions) {
		return null
	}

	const filteredQuestions = getFilteredQuestions({
		allQuestions,
		questionsIds,
		isLoyalty: userDetails.loyalty,
	})

	return filteredQuestions ? (
		<ClientHelpModule titleKey='profile.help.title' moreKey='profile.more.link'>
			{filteredQuestions.map((question) => (
				<ModalHelp
					key={`${question?.question.key}-${question?.question.categoryKey}`}
					question={question}
				/>
			))}
		</ClientHelpModule>
	) : null
}
